import { HotspotType } from '../../components/ResizeContainer/Hotspot/types';

export interface ImageComponentProps {
  src?: string;
  srcset?: string;
  alt?: string;
  id?: string;
  caption?: string;
  layout?: string;
  width?: number;
  height?: number;
  maxHeight?: number;
  showFullWidth?: boolean;
  hotspots?: HotspotType[] | null;
  hotspotsEnabled?: boolean;
  className?: string;
  isUploadingExternally?: boolean;
  disableResizing?: boolean;
}

export enum ImageLayoutTypes {
  None = 'None',
  Card = 'Card',
  Mobile = 'Mobile',
  Web = 'Web',
}
